/* eslint-disable max-len */
import React from 'react'

const ratio = 123 / 51
export default function BlueDarkTiles({ className = undefined, height = 51 }) {
  return (
    <svg
      id="emMp325Pl8N1"
      className={className}
      width={height * ratio}
      height={height}
      viewBox="0 0 123 51"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      shapeRendering="geometricPrecision"
      textRendering="geometricPrecision"
    >
      <g transform="translate(42.470001 0)">
        <polygon
          id="emMp325Pl8N5"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(-.127478-.149433)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.4,10.9 19,4.7 35.6,10.9"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#005992" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="emMp325Pl8N10"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="emMp325Pl8N11"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="emMp325Pl8N12"
            points="36.6,10.5 36.6,7.5 19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(63.703999 8.148)">
        <polygon
          id="emMp325Pl8N14"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.3,10.8 19,4.7 35.6,10.9"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#005992" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="emMp325Pl8N19"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="emMp325Pl8N20"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="emMp325Pl8N21"
            points="19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7 36.6,10.5 36.6,7.5"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(21.235001 8.148)">
        <polygon
          id="emMp325Pl8N23"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.150888-.150887)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.4,10.9 19,4.7 35.6,10.9"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#005992" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="emMp325Pl8N28"
            points="1.5,7.6 19,14.1 36.6,7.6"
            transform="translate(-.000001 0)"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="emMp325Pl8N29"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="emMp325Pl8N30"
            points="22.7,2.4 19,1 1.5,7.5 1.5,10.5 15.3,15.7 15.3,16.4 18.4,17.5 19,17.3 19.7,17.5 22.7,16.4 22.7,15.7 36.6,10.5 36.6,8.3 36.6,7.5"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(84.938004 16.296)">
        <polygon
          id="emMp325Pl8N32"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.4,10.9 19,4.7 36.6,11.2"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#005992" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="emMp325Pl8N37"
            points="1.5,7.5 19,14.1 36.6,7.5"
            transform="translate(0-.127478)"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="emMp325Pl8N38"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="emMp325Pl8N39"
            points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 15.3,16.4 15.3,15.7 1.5,10.5"
            transform="translate(-.127479 0)"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(42.420002 16.296)">
        <polygon
          id="emMp325Pl8N41"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.127478 0)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.4,10.9 19,4.7 35.6,10.9"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#005992" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="emMp325Pl8N46"
            points="1.5,7.5 19,14.1 36.6,7.5"
            transform="translate(-.117366 0)"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="emMp325Pl8N47"
            x1="19"
            y1="17.3"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="emMp325Pl8N48"
            points="1.5,7.5 19,1 36.6,7.5 36.6,10.5 22.7,15.7 22.7,16.4 19.7,17.5 19,17.3 18.4,17.5 15.3,16.4 15.3,15.7 1.5,10.5"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(0 16.296)">
        <polygon
          id="emMp325Pl8N50"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.117366 0)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="1.5,11.2 1.5,11.2 19,4.7 35.6,10.9"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#005992" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="emMp325Pl8N55"
            points="1.5,7.5 19,14.1 36.6,7.5"
            transform="translate(.127479 0)"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="emMp325Pl8N56"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="emMp325Pl8N57"
            points="1.5,7.5 19,1 36.6,7.5 36.6,10.5 22.7,15.7 22.7,16.4 19,17.8 1.5,11.2"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(63.703999 24.444)">
        <polygon
          id="emMp325Pl8N59"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(0 0.278366)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="2.3,10.8 19,4.7 36.6,11.2"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#005992" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="emMp325Pl8N64"
            points="1.5,7.6 19,14.1 36.6,7.6"
            transform="translate(-.146131-.127478)"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="emMp325Pl8N65"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="emMp325Pl8N66"
            points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 15.3,16.4 15.3,15.7 1.5,10.5"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(21.235001 24.444)">
        <polygon
          id="emMp325Pl8N68"
          points="1.5,7.6 19,1 36.6,7.6 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(.127479-.117366)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="1.5,11.2 1.5,11.2 19,4.7 35.6,10.9"
            transform="translate(.117367 0)"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#005992" strokeWidth="0.6" />
        </g>
        <g>
          <polyline
            id="emMp325Pl8N73"
            points="1.5,7.6 19,14.1 36.6,7.6"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <line
            id="emMp325Pl8N74"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="emMp325Pl8N75"
            points="1.5,7.6 19,1 36.6,7.6 36.6,10.5 22.7,15.7 22.7,16.4 19,17.8 1.5,11.2"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <g transform="translate(42.470001 32.592999)">
        <polygon
          id="emMp325Pl8N77"
          points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
          transform="translate(0 0.117366)"
          clipRule="evenodd"
          fill="none"
          fillOpacity="0.3"
          fillRule="evenodd"
        />
        <g>
          <polyline
            points="1.5,11.2 1.5,11.2 19,4.7 36.6,11.2"
            fill="none"
            stroke="#005992"
            strokeWidth="0.6"
          />
          <line x1="19" y1="1" x2="19" y2="4.7" fill="none" stroke="#005992" strokeWidth="0.6" />
        </g>
        <g>
          <line
            id="emMp325Pl8N82"
            x1="19"
            y1="17.8"
            x2="19"
            y2="14.1"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polyline
            id="emMp325Pl8N83"
            points="1.5,7.5 19,14.1 36.6,7.5"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
          <polygon
            id="emMp325Pl8N84"
            points="1.5,7.5 19,1 36.6,7.5 36.6,11.2 19,17.8 1.5,11.2"
            fill="none"
            stroke="#00abe8"
            strokeWidth="0.8"
          />
        </g>
      </g>
      <style>
        {`#emMp325Pl8N5 {animation: emMp325Pl8N5_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N5_f_p { 0% {fill: none} 2.941176% {fill: none} 5.882353% {fill: #00abe8} 14.705882% {fill: #00abe8} 17.647059% {fill: none} 55.882353% {fill: none} 58.823529% {fill: #00abe8} 67.647059% {fill: #00abe8} 70.588235% {fill: none} 73.529412% {fill: none} 76.470588% {fill: #00abe8} 85.294118% {fill: #00abe8} 88.235294% {fill: none} 100% {fill: none}} #emMp325Pl8N10 {animation: emMp325Pl8N10_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N10_s_p { 0% {stroke: #00abe8} 2.941176% {stroke: #00abe8} 5.882353% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 55.882353% {stroke: #00abe8} 58.823529% {stroke: #82d4f2} 61.764706% {stroke: #82d4f2} 64.705882% {stroke: #00abe8} 73.529412% {stroke: #00abe8} 76.470588% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N11 {animation: emMp325Pl8N11_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N11_s_p { 0% {stroke: #00abe8} 2.941176% {stroke: #00abe8} 5.882353% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 55.882353% {stroke: #00abe8} 58.823529% {stroke: #82d4f2} 61.764706% {stroke: #82d4f2} 64.705882% {stroke: #00abe8} 73.529412% {stroke: #00abe8} 76.470588% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N12 {animation: emMp325Pl8N12_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N12_s_p { 0% {stroke: #00abe8} 2.941176% {stroke: #00abe8} 5.882353% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 55.882353% {stroke: #00abe8} 58.823529% {stroke: #82d4f2} 61.764706% {stroke: #82d4f2} 64.705882% {stroke: #00abe8} 73.529412% {stroke: #00abe8} 76.470588% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N14 {animation: emMp325Pl8N14_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N14_f_p { 0% {fill: none} 2.941176% {fill: none} 5.882353% {fill: #00abe8} 14.705882% {fill: #00abe8} 17.647059% {fill: none} 50% {fill: none} 52.941176% {fill: #00abe8} 61.764706% {fill: #00abe8} 64.705882% {fill: none} 79.411765% {fill: none} 82.352941% {fill: #00abe8} 88.235294% {fill: #00abe8} 91.176471% {fill: #00abe8} 94.117647% {fill: none} 100% {fill: none}} #emMp325Pl8N19 {animation: emMp325Pl8N19_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N19_s_p { 0% {stroke: #00abe8} 2.941176% {stroke: #00abe8} 5.882353% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 58.823529% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N20 {animation: emMp325Pl8N20_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N20_s_p { 0% {stroke: #00abe8} 2.941176% {stroke: #00abe8} 5.882353% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 50% {stroke: #82d4f2} 52.941176% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 58.823529% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N21 {animation: emMp325Pl8N21_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N21_s_p { 0% {stroke: #00abe8} 2.941176% {stroke: #00abe8} 5.882353% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 58.823529% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N23 {animation: emMp325Pl8N23_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N23_f_p { 0% {fill: none} 8.823529% {fill: none} 11.764706% {fill: #00abe8} 14.705882% {fill: #00abe8} 20.588235% {fill: #00abe8} 23.529412% {fill: none} 50% {fill: none} 52.941176% {fill: #00abe8} 61.764706% {fill: #00abe8} 64.705882% {fill: none} 73.529412% {fill: none} 76.470588% {fill: #00abe8} 85.294118% {fill: #00abe8} 88.235294% {fill: none} 100% {fill: none}} #emMp325Pl8N28 {animation: emMp325Pl8N28_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N28_s_p { 0% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 58.823529% {stroke: #00abe8} 61.764706% {stroke: #00abe8} 73.529412% {stroke: #00abe8} 76.470588% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N29 {animation: emMp325Pl8N29_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N29_s_p { 0% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 58.823529% {stroke: #00abe8} 61.764706% {stroke: #00abe8} 73.529412% {stroke: #00abe8} 76.470588% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N30 {animation: emMp325Pl8N30_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N30_s_p { 0% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 50% {stroke: #00abe8} 52.941176% {stroke: #82d4f2} 55.882353% {stroke: #82d4f2} 58.823529% {stroke: #00abe8} 61.764706% {stroke: #00abe8} 73.529412% {stroke: #00abe8} 76.470588% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N32 {animation: emMp325Pl8N32_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N32_f_p { 0% {fill: none} 2.941176% {fill: none} 5.882353% {fill: #00abe8} 14.705882% {fill: #00abe8} 17.647059% {fill: none} 44.117647% {fill: none} 47.058824% {fill: #00abe8} 55.882353% {fill: #00abe8} 58.823529% {fill: none} 85.294118% {fill: none} 88.235294% {fill: #00abe8} 97.058824% {fill: #00abe8} 100% {fill: none}} #emMp325Pl8N37 {animation: emMp325Pl8N37_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N37_s_p { 0% {stroke: #00abe8} 2.941176% {stroke: #00abe8} 5.882353% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 94.117647% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N38 {animation: emMp325Pl8N38_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N38_s_p { 0% {stroke: #00abe8} 2.941176% {stroke: #00abe8} 5.882353% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 94.117647% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N39 {animation: emMp325Pl8N39_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N39_s_p { 0% {stroke: #00abe8} 2.941176% {stroke: #00abe8} 5.882353% {stroke: #82d4f2} 8.823529% {stroke: #82d4f2} 11.764706% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 94.117647% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N41 {animation: emMp325Pl8N41_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N41_f_p { 0% {fill: none} 8.823529% {fill: none} 11.764706% {fill: #00abe8} 14.705882% {fill: #00abe8} 20.588235% {fill: #00abe8} 23.529412% {fill: none} 44.117647% {fill: none} 47.058824% {fill: #00abe8} 55.882353% {fill: #00abe8} 58.823529% {fill: none} 79.411765% {fill: none} 82.352941% {fill: #00abe8} 88.235294% {fill: #00abe8} 91.176471% {fill: #00abe8} 94.117647% {fill: none} 100% {fill: none}} #emMp325Pl8N46 {animation: emMp325Pl8N46_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N46_s_p { 0% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N47 {animation: emMp325Pl8N47_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N47_s_p { 0% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N48 {animation: emMp325Pl8N48_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N48_s_p { 0% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N50 {animation: emMp325Pl8N50_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N50_f_p { 0% {fill: none} 14.705882% {fill: none} 17.647059% {fill: #00abe8} 26.470588% {fill: #00abe8} 29.411765% {fill: none} 44.117647% {fill: none} 47.058824% {fill: #00abe8} 55.882353% {fill: #00abe8} 58.823529% {fill: none} 73.529412% {fill: none} 76.470588% {fill: #00abe8} 85.294118% {fill: #00abe8} 88.235294% {fill: none} 100% {fill: none}} #emMp325Pl8N55 {animation: emMp325Pl8N55_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N55_s_p { 0% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 20.588235% {stroke: #82d4f2} 23.529412% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 73.529412% {stroke: #00abe8} 76.470588% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N56 {animation: emMp325Pl8N56_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N56_s_p { 0% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 20.588235% {stroke: #82d4f2} 23.529412% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 73.529412% {stroke: #00abe8} 76.470588% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N57 {animation: emMp325Pl8N57_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N57_s_p { 0% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 20.588235% {stroke: #82d4f2} 23.529412% {stroke: #00abe8} 44.117647% {stroke: #00abe8} 47.058824% {stroke: #82d4f2} 50% {stroke: #82d4f2} 52.941176% {stroke: #00abe8} 73.529412% {stroke: #00abe8} 76.470588% {stroke: #82d4f2} 79.411765% {stroke: #82d4f2} 82.352941% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N59 {animation: emMp325Pl8N59_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N59_f_p { 0% {fill: none} 8.823529% {fill: none} 11.764706% {fill: #00abe8} 14.705882% {fill: #00abe8} 20.588235% {fill: #00abe8} 23.529412% {fill: none} 38.235294% {fill: none} 41.176471% {fill: #00abe8} 47.058824% {fill: #00abe8} 50% {fill: #00abe8} 52.941176% {fill: none} 85.294118% {fill: none} 88.235294% {fill: #00abe8} 97.058824% {fill: #00abe8} 100% {fill: none}} #emMp325Pl8N64 {animation: emMp325Pl8N64_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N64_s_p { 0% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 38.235294% {stroke: #00abe8} 41.176471% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 94.117647% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N65 {animation: emMp325Pl8N65_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N65_s_p { 0% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 38.235294% {stroke: #00abe8} 41.176471% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 94.117647% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N66 {animation: emMp325Pl8N66_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N66_s_p { 0% {stroke: #00abe8} 8.823529% {stroke: #00abe8} 11.764706% {stroke: #82d4f2} 14.705882% {stroke: #82d4f2} 17.647059% {stroke: #00abe8} 38.235294% {stroke: #00abe8} 41.176471% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 94.117647% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N68 {animation: emMp325Pl8N68_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N68_f_p { 0% {fill: none} 14.705882% {fill: none} 17.647059% {fill: #00abe8} 26.470588% {fill: #00abe8} 29.411765% {fill: none} 38.235294% {fill: none} 41.176471% {fill: #00abe8} 47.058824% {fill: #00abe8} 50% {fill: #00abe8} 52.941176% {fill: none} 79.411765% {fill: none} 82.352941% {fill: #00abe8} 91.176471% {fill: #00abe8} 94.117647% {fill: none} 100% {fill: none}} #emMp325Pl8N73 {animation: emMp325Pl8N73_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N73_s_p { 0% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 20.588235% {stroke: #82d4f2} 23.529412% {stroke: #00abe8} 38.235294% {stroke: #00abe8} 41.176471% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N74 {animation: emMp325Pl8N74_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N74_s_p { 0% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 20.588235% {stroke: #82d4f2} 23.529412% {stroke: #00abe8} 38.235294% {stroke: #00abe8} 41.176471% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N75 {animation: emMp325Pl8N75_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N75_s_p { 0% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 20.588235% {stroke: #82d4f2} 23.529412% {stroke: #00abe8} 38.235294% {stroke: #00abe8} 41.176471% {stroke: #82d4f2} 44.117647% {stroke: #82d4f2} 47.058824% {stroke: #00abe8} 79.411765% {stroke: #00abe8} 82.352941% {stroke: #82d4f2} 85.294118% {stroke: #82d4f2} 88.235294% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N77 {animation: emMp325Pl8N77_f_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N77_f_p { 0% {fill: none} 14.705882% {fill: none} 17.647059% {fill: #00abe8} 26.470588% {fill: #00abe8} 29.411765% {fill: none} 32.352941% {fill: none} 35.294118% {fill: #00abe8} 44.117647% {fill: #00abe8} 47.058824% {fill: none} 85.294118% {fill: none} 88.235294% {fill: #00abe8} 91.176471% {fill: #00abe8} 97.058824% {fill: #00abe8} 100% {fill: none}} #emMp325Pl8N82 {animation: emMp325Pl8N82_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N82_s_p { 0% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 20.588235% {stroke: #82d4f2} 23.529412% {stroke: #00abe8} 32.352941% {stroke: #00abe8} 35.294118% {stroke: #82d4f2} 38.235294% {stroke: #82d4f2} 41.176471% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 94.117647% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N83 {animation: emMp325Pl8N83_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N83_s_p { 0% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 20.588235% {stroke: #82d4f2} 23.529412% {stroke: #00abe8} 32.352941% {stroke: #00abe8} 35.294118% {stroke: #82d4f2} 38.235294% {stroke: #82d4f2} 41.176471% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 94.117647% {stroke: #00abe8} 100% {stroke: #00abe8}} #emMp325Pl8N84 {animation: emMp325Pl8N84_s_p 2428.571428571429ms linear infinite normal forwards}@keyframes emMp325Pl8N84_s_p { 0% {stroke: #00abe8} 14.705882% {stroke: #00abe8} 17.647059% {stroke: #82d4f2} 20.588235% {stroke: #82d4f2} 23.529412% {stroke: #00abe8} 32.352941% {stroke: #00abe8} 35.294118% {stroke: #82d4f2} 38.235294% {stroke: #82d4f2} 41.176471% {stroke: #00abe8} 85.294118% {stroke: #00abe8} 88.235294% {stroke: #82d4f2} 91.176471% {stroke: #82d4f2} 94.117647% {stroke: #00abe8} 100% {stroke: #00abe8}}`}
      </style>
    </svg>
  )
}
